import { Injectable, Injector } from "@angular/core";
import {
  HttpHeaders,
} from "@angular/common/http";

import { saveAs } from "file-saver";

import { ApplicationApiService } from "./application-api.service";
import { ModalPDFViewerService } from "src/app/shared/components/pdf-viewer/pdf-viewer.service";
import { NgxSpinnerService } from "ngx-spinner"; // Assuming you have this or similar

function SafelyParseJSON(json) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return;
  }
}

export interface SendTo {
  emails?: string[];
  waNumbers?: string[];
  text?: string;
}

@Injectable()
export class PDFService extends ApplicationApiService {
  constructor(
    protected injector: Injector,
    private pdfViewerService: ModalPDFViewerService,
    private spinnerService: NgxSpinnerService // Inject a loading spinner service
  ) {
    super(injector);
  }

  public get(
    url: string,
    search?: { [key: string]: any | any[] },
    fileName: string = "relatorio",
    sendTo: SendTo = null
  ): Promise<any> {
    const rep_type = (search ? search["rep_type"] : "pdf") || "pdf";
    // return this.request('GET', url, { params: this.createHttpParams(search), rep_type }, fileName);
    return this.getReport(
      "GET",
      url,
      { params: this.createHttpParams(search), rep_type, sendTo },
      fileName
    );
  }

  public post(
    url: string,
    body: any,
    fileName: string = "relatorio",
    sendTo: SendTo = null
  ): Promise<any> {
    // return this.request('POST', url, { body: JSON.stringify(body) }, fileName);
    return this.getReport(
      "POST",
      url,
      { body: JSON.stringify(body), sendTo },
      fileName
    );
  }

  private getReport(
    method: string,
    url: string,
    options: any,
    fileName: string = "relatorio"
  ): Promise<any> {
    const repType = (options ? options["rep_type"] : "pdf") || "pdf";
    const repName = fileName.endsWith(repType) ? fileName : `${fileName}.${repType}`;

    let waNumbers: string[];
    let waText: string = null;
    const sendTo = options ? options["sendTo"] : null;
    if (sendTo) {
      // Verifica se há números de WhatsApp para envio do arquivo
      waNumbers = sendTo["waNumbers"] || [];

      // Verifica se há texto para enviar
      waText = sendTo["text"];
    }

    // Show loading spinner using a service
    this.spinnerService.show()

    options["responseType"] = "blob";
    options["headers"] = new HttpHeaders({
      Accept: `application/${repType}, application/json`,
      "content-type":
        method === "POST" ? "application/json" : `application/${repType}`,
    });

    return new Promise<any>((resolve, reject) => {
      return this.http
        .request(method, url, options)
        .pipe()
        .subscribe(
          (resp) => {
            try {
              // Hide spinner
              this.spinnerService.hide();

              const blobObj = new Blob([resp], { type: "application/pdf" });

              if (repType !== "pdf") {
                const blobURL = URL.createObjectURL(blobObj);
                saveAs(blobURL, repName);
              } else {
                this.pdfViewerService.show({
                  src: blobObj,
                  filename: repName,
                  title: fileName,
                  waNumbers,
                  waText,
                });
              }

              resolve({ ok: true });
            } catch (e) {
              console.log("catch", e);
              this.spinnerService.hide();
              resolve({ ok: false });
            }
          },
          async (err) => {
            console.log("err", await err.error.text());
            // Hide spinner
            this.spinnerService.hide();

            try {
              const fr = new FileReader();
              fr.onload = () => reject({ ok: false, error: SafelyParseJSON(fr.result) });
              fr.readAsText(err.error);
            } catch (readError) {
              reject({
                ok: false,
                error: SafelyParseJSON(await err.error.text()),
              });
            }
          }
        );
    });
  }
}
